import { render } from "./RegistrationNetwork.vue?vue&type=template&id=1d5bd790&scoped=true"
import script from "./RegistrationNetwork.vue?vue&type=script&lang=js"
export * from "./RegistrationNetwork.vue?vue&type=script&lang=js"

import "./RegistrationNetwork.vue?vue&type=style&index=0&id=1d5bd790&lang=scss"
import "./RegistrationNetwork.vue?vue&type=style&index=1&id=1d5bd790&lang=scss&scoped=true"
import "./RegistrationNetwork.vue?vue&type=style&index=2&id=1d5bd790&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d5bd790"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBanner,QBtn,QTooltip,QIcon,QTd,QToggle,QDialog,QCard,QToolbar,QToolbarTitle,QCardSection,QCardActions,QTable,QField});
